import info from '~/assets/icons/info_2.svg';
import success from '~/assets/icons/success.svg';
import warning from '~/assets/icons/warning.svg';
import { NotificationStyle } from '~/shared';

import { Divider } from '../Divider';
import { NotificationText } from '../NotificationText';
import { StyledNotificationContainer } from './InfoNotification.styled';

interface IHudInfoNotificationProps
	extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	notificationStyle: NotificationStyle;
	$layerIndex?: number;
}

const NotificationIcons = {
	[NotificationStyle.Info]: info,
	[NotificationStyle.Success]: success,
	[NotificationStyle.Error]: warning,
};

const InfoNotification: React.FC<IHudInfoNotificationProps> = ({
	text,
	notificationStyle,
	...props
}: IHudInfoNotificationProps) => {
	if (
		notificationStyle === NotificationStyle.Progress ||
		notificationStyle === NotificationStyle.Counter
	) {
		return null;
	}

	const mergedClassName = [notificationStyle, props.className]
		.filter(Boolean)
		.join(' ');

	return (
		<StyledNotificationContainer {...props} className={mergedClassName}>
			<img src={NotificationIcons[notificationStyle]} />
			<Divider
				$color={
					notificationStyle === NotificationStyle.Info ? 'black' : 'white'
				}
			/>
			<NotificationText
				$color={
					notificationStyle === NotificationStyle.Info ? 'black' : 'white'
				}
			>
				{text}
			</NotificationText>
		</StyledNotificationContainer>
	);
};

export { InfoNotification };
